"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingContent = void 0;
exports.PricingContent = {
  en: {
    inCart: "In cart",
    seePriceInCart: "See price in cart"
  },
  fr: {
    inCart: "Dans le panier",
    seePriceInCart: "Voir le prix dans le panier"
  },
  es: {
    inCart: "En el carrito",
    seePriceInCart: "Mira el precio en la carta"
  }
};